import type { ComponentProps } from "react";
import { Button } from "@components/ui/button";

interface DevButtonProps extends ComponentProps<typeof Button> {
  /** Render outside development too (e.g. admin-only tools in production). */
  forceShow?: boolean;
}

/**
 * Dev-only button that only renders in development mode (or when the
 * caller forces it, for admin tools). Red styling to make it obvious
 * this is a dev/admin tool.
 */
export default function DevButton({ children, className, forceShow, ...props }: DevButtonProps) {
  if (!import.meta.env.DEV && !forceShow) return null;

  return (
    <Button
      variant="outline"
      className={`border-red-300 bg-red-50 text-red-700 hover:bg-red-100 hover:text-red-800 ${className ?? ""}`}
      {...props}
    >
      {children}
    </Button>
  );
}
